// Shared by both domains. GitHub resolves "latest" when the visitor downloads.
export const DOWNLOAD_LINKS = Object.freeze({
  windows: "https://github.com/Blender-Bridge/blender-bridge/releases/latest/download/Blender_Bridge_Installer.exe",
  /*
   * Метка источника для статистики магазина Chrome (Google Analytics карточки
   * расширения): ссылка открывается с noreferrer, и без метки установка с сайта
   * неотличима от установки из поиска магазина.
   */
  extension: "https://chromewebstore.google.com/detail/blender-bridge/lgdjpajmggpkjcdogglbeipbkckdpoki?utm_source=blenderbridge&utm_medium=site",
});
